export const SLIDE_META = [
  { id: "problem", n: "01", label: "Less Friction, More Action" },
  { id: "works", n: "02", label: "How It Works" },
  { id: "mechanism", n: "03", label: "The Mechanism" },
  { id: "gap", n: "04", label: "The Gap" },
  { id: "today", n: "05", label: "Available Today" },
  { id: "whynow", n: "06", label: "Why Now" },
  { id: "traction", n: "07", label: "Traction" },
  { id: "pilot", n: "08", label: "First Pilot" },
  { id: "clinical", n: "09", label: "Clinical & Adherence" },
  { id: "defensibility", n: "10", label: "Defensibility" },
  { id: "landscape", n: "11", label: "Landscape" },
  { id: "customer", n: "12", label: "Customer & Brand" },
  { id: "business", n: "13", label: "Business Model" },
  { id: "team", n: "14", label: "Team" },
  { id: "raise", n: "15", label: "The Raise" },
  { id: "bigquestion", n: "16", label: "The Big Question" },
  { id: "going", n: "17", label: "Where It's Going" },
];
